import React from 'react'

export function OR8p5inchStyle() {
  return (
    <style jsx='true'>
    {`
      /* Modify Parent Style Content Inner */
      #content {
        background-color: whitesmoke;
      }

      .report-wrapper { border: solid 0.5px lightgrey; }

      /* RECEIPT ITEM CONTAINER */
      .OR8p5inch#or-item-container {
        display: flex;
        flex-direction: column;
        justify-content: stretch;
        background-color: white;
        /*border: solid 1px lightgrey;*/
        font-size: 0.95rem;
        padding: 20px;
        box-sizing: border-box;
        /*box-shadow: 2px 2px 10px 2px #BBB;*/
      }

      /* RECEIPT HEADER */
      .OR8p5inch .receipt-header {
        display: grid;
        grid-gap: 5px;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr;
      }
      .OR8p5inch .or-date { text-align: right; }
      .OR8p5inch .or-label { font-size: 1.1rem; }

      /* RECEIPT INNER */
      .receipt-inner {
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        margin-bottom: 10px;
      }
      .receipt-inner-message {
        margin-bottom: 10px;
        flex: 1;
      }
      .receipt-summary {
        width: 43%;
        align-self: flex-end;
        display: flex;
        flex-direction: column;
        margin-top: 10pt;
        align-items: stretch;
      }
      .receipt-summary-item { display: flex; }
      .receipt-summary-item.sub-content { margin-left: 10px; }
      .receipt-summary-label { flex: 3; }
      .receipt-summary-data {
        flex: 1;
        text-align: right;
        font-weight: bold;
      }
      .receipt-summary-item.sub-content .receipt-summary-label { font-size: 0.9em; }
      .receipt-summary-item.sub-content .receipt-summary-data {
        font-weight: normal;
        font-size: 0.9em;
      }
      .discount-info-label { margin-left: 5px; flex: 1; }
      .discount-info-data { flex: 3; }
      .discount-info-data.signature-underline { border-bottom: solid 1px black; }

      /* RECEIPT FOOTER */
      .OR8p5inch .receipt-footer {
        margin-top: 50px;
        display: grid;
        grid-template-columns: 1fr 1fr;
      }
      /*.OR8p5inch .paid-by-container, .OR8p5inch .prepared-by-container { display: flex; }*/
      .paid-by-container, .prepared-by-container { display: flex; }
      .OR8p5inch .prepared-by-container { justify-content: flex-end; }
      .OR8p5inch .paid-by-name, .OR8p5inch .prepared-by-name { border-bottom: 0.3px solid black; text-align: center; }
      .OR8p5inch .paid-by-label, .OR8p5inch .prepared-by-label { font-weight: bold; }

      .log-container {
        font-size: 0.8rem;
        margin-top: 10px;
        border-top: dotted 0.3px black;
      }
    `}
    </style>
  )
}

export function OR58mmStyle() {
  return (
    <style jsx='true'>
    {`
      .OR58mm {
        display: flex;
        visibility: hidden;
        flex-direction: column;
        align-items: center;
        padding: 10px;
        height: 0vh;
        overflow: hidden;
        box-sizing: border-box;
      }

      /* RECEIPT HEADER */
      .OR58mm .receipt-header {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
      }

      .OR58mm .receipt-details-container {
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        width: 100%;
      }

      /* RECEIPT INNER */
      .OR58mm .receipt-inner { width: 100%; }
      .OR58mm .receipt-summary { width: 100%; }

      /* RECEIPT FOOTER */
      .OR58mm .receipt-footer { display: flex; width: 100%; }
      .OR58mm .paid-by-label, .OR58mm .prepared-by-label { font-weight: bold; margin-right: 5px; }
      .OR58mm .paid-by-data, .OR58mm .prepared-by-data { }
    `}
    </style>
  )
}

export function EMSI8p5inchStyle() {
  return (
    <style jsx='true'>
    {`
      /* Modify Parent Style Content Inner */
      #content{
        background-color: whitesmoke
      }

      .report-wrapper { border: solid 0.5px lightgrey; }

      /* INVOICE ITEM CONTAINER */
      #invoice-item-container {
        display: flex;
        flex-direction: column;
        justify-content: stretch;
        background-color: white;
        /*border: solid 1px lightgrey;*/
        font-size: 0.95rem;
        padding: 20px;
        box-sizing: border-box;
        /*font-family: 'Courier New';*/
        /*box-shadow: 2px 2px 10px 2px #BBB;*/
      }

      /* HEADER */
      #invoice-item-header {
        /*background-color: green;*/
        display: flex;
        flex-direction: row;
        justify-content: stretch;
      }
      #invoice-item-header-left {
        /*background-color: violet;*/
        display: flex;
        flex-direction: column;
        align-items: left;
        flex: 1;
      }
      #invoice-item-header-right {
        /*background-color: yellow;*/
        display: flex;
        flex-direction: column;
        align-items: right;
        justify-content: flex-start;
        flex: 1;
      }
      #table-customer-details th, #table-customer-details td {
        /* border: 1px solid green; */
        vertical-align: middle;
      }

      /* INVOICE PARTICULARS */
      .table-invoice-item {
        margin-top: 10pt;
        border-spacing: 3;
      }

      /* INVOICE SUMMARY */
      .invoice-summary-container {
        width: 37%;
        align-self: flex-end;
        display: flex;
        flex-direction: column;
        margin-top: 10pt;
        display: flex;
        justify-content: flex-end;
      }
      .invoice-summary-item {
        display: flex;
        flex: 2;
      }
      .invoice-summary-item.sub-content {
        margin-left: 10px;
        font-size: 0.9em;
      }
      .item-label { flex: 3;}
      .item-data {
        flex: 2;
        text-align: right;
      }
      .discount-info-label { margin-left: 5px; flex: 1; }
      .discount-info-data { flex: 3; }
      .discount-info-data.signature-underline { border-bottom: solid 1px black; }

      .paid-by-container, .prepared-by-container { display: flex; }
      .prepared-by-container { justify-content: flex-end; }
      .paid-by-label, .prepared-by-label { font-weight: bold; margin-right: 5px; }
      .paid-by-name, .prepared-by-name { border-bottom: 0.3px solid black; text-align: center; }

      .log-container {
        font-size: 0.8rem;
        margin-top: 10px;
        border-top: dotted 0.3px black;
      }
    `}
    </style>
  )
}

export function EMSI58mmStyle() {
  return (
    <style jsx='true'>
    {`
      .invoice-58mm {
        display: flex;
        visibility: hidden;
        flex-direction: column;
        align-items: center;
        padding: 10px;
        height: 0vh;
        overflow: hidden;
        box-sizing: border-box;
      }

      #invoice-58mm-header {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 10px;
        width: 100%;
      }

      #invoice-details-container {
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        width: 100%;
      }

      .invoice-58mm .invoice-details-show {
        display: flex;
        flex-direction: column;
      }
      .invoice-58mm .invoice-details-hide { display: none; }

      .invoice-58mm .items-list { width: 100%; }

      .invoice-58mm .invoice-summary-container { width: 100%; }

      .invoice-58mm .prepared-by-container {
        justify-content: flex-start;
        width: 100%;
      }
      .invoice-58mm .prepared-by-label { margin-right: 5px; }

    `}
    </style>
  )
}
